/* ==============================================================================================
 * ISSUE DETAILS MODAL
 * ============================================================================================== */

var Sushi, CGS, $ = window.jQuery;

(function (Sushi, Plugins, CGS) {
	"use strict";

	var BasePlugin = Plugins.BasePlugin;
	var OffCanvas = Plugins.OffCanvas;
	var Events = Sushi.Events;

	var IssueDetail = function (triggerElement, options) {
		if (Sushi.getPluginInstance("IssueDetail", triggerElement)) {
			return;
		}

		this.element = triggerElement;
		this.onExportList = this.onExportList || false;
		this.addToExportListButton = null;

		BasePlugin.call(this, this.element, options);

		var content = this.options.content ? this.options.content : "#issueDetailModal";

		this.element.setAttribute("href", "#");
		this.element.setAttribute("data-off-canvas-content", content);
		this.element.setAttribute("data-off-canvas-position", "top right");
		this.element.setAttribute("data-off-canvas-from", "right");
		this.element.setAttribute("data-off-canvas-lock-scroll", "true");
		this.element.setAttribute("data-off-canvas-modifiers", "offCanvas medium");
		this.element.setAttribute("data-off-canvas-opens-from-hash", "false");
		this.element.setAttribute("data-off-canvas-close-on-overlay-click", "true");

		this.modal = new OffCanvas(this.element);

		Events(this.modal.element).on("Modal.open", this.handleModalOpen.bind(this));
		Events(this.modal.element).on("Modal.close", this.handleModalClose.bind(this));
	};

	IssueDetail.displayName = "IssueDetail";

	IssueDetail.prototype = Object.create(BasePlugin.prototype);

	var proto = IssueDetail.prototype;

	proto.constructor = IssueDetail;

	proto.handleAddToExportListClick = function (event) {
		this.onExportList = !this.onExportList;

		if (this.onExportList) {
			event.target.classList.add("on-export-list");
			event.target.innerText = "Remove from Export List";
		}
		else {
			event.target.classList.remove("on-export-list");
			event.target.innerText = "Add to Export List";
		}
	};

	proto.handleModalClose = function () {
		this.triggerElement.closest("tr").classList.remove("c-table__row--active");
	};

	proto.handleModalOpen = function () {
		this.triggerElement.closest("tr").classList.add("c-table__row--active");
		this.addToExportListButton = this.modal.element.querySelector("[data-feature=addToExportList]");

		if (this.addToExportListButton) {
			this.addToExportListButton.addEventListener("click", this.handleAddToExportListClick);
		}

		var issuerLastUpdatedElement = this.modal.element.querySelector("[data-issuer-last-updated]");
		var issuerNumberElement = this.modal.element.querySelector("[data-issuer-number]");

		var issuerLastUpdated = this.options.issuerLastUpdated;
		var issuerNumber = this.options.issuerNumber;

		if (issuerLastUpdatedElement && issuerLastUpdated) {
			issuerLastUpdatedElement.innerHTML = issuerLastUpdated;
		}

		if (issuerNumberElement && issuerNumber) {
			issuerNumberElement.innerHTML = issuerNumber;
		}

		// TODO: Update api endpoint URL
		var apiEndpoint = "/json/access/issuerIssueDetails.json";

		var tableElement = this.modal.element.querySelector("table");

		var columns = [
			{
				"data": "label",
				"className": "c-table__cell",
			},
			{
				"data": null,
				"className": "c-table__cell",
			},
		];

		var columnDefs = [
			{
				targets: [ 1 ],
				render: function (data) {
					var cellData = data.value;
					var uid = Sushi.Util.uid();

					if (data.details) {
						var btnContainer = document.createElement("div");
						var btn = document.createElement("button");

						btn.classList.add("c-table__showChildRows");

						btnContainer.appendChild(btn);

						cellData += btnContainer.innerHTML;
					}

					if (data.url) {
						var linkContainer = document.createElement("div");
						var link = document.createElement("a");

						link.classList.add("_red");
						link.setAttribute("href", data.url);
						link.setAttribute("href", data.url);
						link.innerText = cellData;

						if (data.hover) {
							link.setAttribute("data-tooltipster", "");
							link.setAttribute("data-tooltip-content", "#" + uid);
						}

						linkContainer.appendChild(link);
						cellData = linkContainer.innerHTML;
					}

					if (data.hover) {
						var tooltipElContainer = document.createElement("div");
						var tooltipWrapper = document.createElement("div");
						var tooltipContent = document.createElement("div");
						var infoKeys = Object.keys(data.hover);

						for (var i = 0; i < infoKeys.length; i++) {
							if (i !== 0) {
								var divisor = document.createElement("div");

								divisor.classList.add("tooltipster-divider");
								tooltipContent.appendChild(divisor);
							}

							var infoWrapper = document.createElement("div");
							var label = document.createElement("div");
							var value = document.createElement("div");

							label.classList.add("_fw6");
							label.innerText = data.hover[infoKeys[i]].label;
							value.innerText = data.hover[infoKeys[i]].value;

							infoWrapper.appendChild(label);
							infoWrapper.appendChild(value);
							tooltipContent.appendChild(infoWrapper);
						}

						tooltipContent.id = uid;
						tooltipContent.classList.add("_df");
						tooltipWrapper.classList.add("_dn");
						tooltipWrapper.appendChild(tooltipContent);
						tooltipElContainer.appendChild(tooltipWrapper);

						cellData += tooltipElContainer.innerHTML;
					}

					return cellData;
				},
			},
		];

		CGS.table(tableElement, {
			ajax: {
				url: apiEndpoint,
				dataSrc: function (json) {
					var issuerData = json.data.issuer;
					var issuesData = json.data.issues;

					var issues = [];

					issuesData.map(function (data) {
						issues.push(data);

						if (!data.details) {
							return;
						}

						data.details.map(function (details) {
							details.type = "detail";

							issues.push(details);
						});
					});

					return [{
						label: "Issuer Data",
						value: "",
						type: "title",
					}]
						.concat(issuerData)
						.concat([{
							type: "empty",
							label: "",
							value: "",
						}])
						.concat([{
							label: "Issue Data",
							value: "",
							type: "title",
						}])
						.concat(issues);
				},
			},
			columns: columns,
			columnDefs: columnDefs,
			paging: false,
			scrollY: "auto",
			dom: "<'_df _mbn _ttu _z10'<'_fxg'><'c-table__export _p0'B>>rt",
			initComplete: function (settings) {
				var scrollHead = settings.nScrollHead;
				var scrollBody = settings.nScrollBody;

				scrollHead.style.display = "none";
				scrollBody.style.overflow = "visible";
				scrollBody.classList.add("_pbxs", "_pb@laptop");
			},
			rowCallback: function (row, data) {
				row.classList.add("c-table__row--compact");

				// if row has details/child rows
				if (data.details) {
					row.classList.add("c-table__row--hasChildren");
					row.setAttribute("data-plugin", "TableRowGroup");

					setTimeout(function () {
						new Sushi.Plugins.TableRowGroup(row);
					});
				}

				if (data.type === "title") {
					row.classList.add("c-table__row--title");
				}
				else if (data.type === "detail") {
					row.classList.add("c-table__row--child");
				}
				else if (data.type === "empty") {
					row.classList.add("c-table__row--empty");
				}

				setTimeout(function () {
					var rowTooltip = row.querySelector("[data-tooltipster]");

					if (rowTooltip) {
						$(rowTooltip).tooltipster({
							theme: "tooltipster--light",
						});
					}
				});
			},
		});
	};

	Plugins.IssueDetail = IssueDetail;

})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}), CGS || (CGS = {}));
